import { render, staticRenderFns } from "./AutoEnrollmentContributionTypeRadio.vue?vue&type=template&id=fd0e2d74&"
import script from "./AutoEnrollmentContributionTypeRadio.vue?vue&type=script&lang=js&"
export * from "./AutoEnrollmentContributionTypeRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports